import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { ConveyanceBill } from '../../../models/conveyance-bill.model';
import { ModalService } from 'src/app/shared/services/modal.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { DataService } from '../../../services/forms/configuration/data.service';
import { AlertService } from 'src/app/shared/popup/service/alert.service';
import { CommonService } from '../../../services/common.service';



@Component({
  selector: 'app-conveyance-bill-accounts',
  templateUrl: './../../../templates/forms/modals/conveyance-bill-accounts.component.html',
})
export class ConveyanceBillAccountsComponent implements OnInit {
  @ViewChild('modalContainer', { static: true, read: ViewContainerRef }) container;

  @Input()
  config: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  //@Input()
  public conveyanceBillList: ConveyanceBill[];

  private modal: ModalService;
  public searchString;

  constructor(
    public langService: LangService
    , private commonService: CommonService
    , private alertService: AlertService
    , private dataService: DataService) {
  }

  ngOnInit() {
    this.dataService.getProvConvEmployeess()
      .subscribe(arg => { this.conveyanceBillList = arg.body });
  }

  onClickAddNewConveyance() {
    this.conveyanceBillList.push(new ConveyanceBill());
  }

  onClickOpenEmployeeListModal(_conveyanceBill) {
    this.modal.createEmployeeListComponent(this.container, _conveyanceBill);
  }
  onClickOpenAccountsListModal(_conveyanceBill) {
    this.modal.createAccountsListComponent(this.container, _conveyanceBill);
  }
  onClickRemoveAccountsListModal(index, conveyanceBill) {
    if (conveyanceBill.SQL_STATE == 1) {
      this.conveyanceBillList.splice(index, 1);
    }
    else {
      conveyanceBill.SQL_STATE = fixedValues.sqlState.sqlDelete;
    }
  }
  onClickSave() {
    this.dataService.saveProvisionEmployee(this.conveyanceBillList).subscribe(result => {
      this.alertService.success("Saved Successfully");
    })
  }

}
